var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-select",
    _vm._b(
      {
        attrs: {
          label: _vm.$t("purchase_unit"),
          items: _vm.items,
          disabled: _vm.items.length < 2
        },
        model: {
          value: _vm.purchaseUnit,
          callback: function($$v) {
            _vm.purchaseUnit = $$v
          },
          expression: "purchaseUnit"
        }
      },
      "v-select",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }